import { useSelector } from 'react-redux';
import { RootState } from '../../shared/state/root-reducer';

export function useIsDisabledAfterConvert(): boolean {
  const selectedEncounter = useSelector(
    (state: RootState) => state.patientContext.selectedEncounter
  );
  
  const estimate = useSelector(
    (state: RootState) => state?.estimatorContext.selectedEstimate
  );
  
  // If there's no estimate with patientEncounterId, nothing is disabled (new estimates)
  if (!estimate?.patientEncounterId) {
    return false;
  }
  
  // If there's no selected encounter yet, nothing is disabled (still loading)
  if (!selectedEncounter) {
    return false;
  }
  
  // Check if this estimate is linked to the current encounter
  const isEstimateLinkedToEncounter = estimate.estimateId === selectedEncounter.pfrEstimateId;
  
  // Check if the encounter is converted (IOC created)
  const isEncounterConverted = selectedEncounter.isConverted || selectedEncounter.workflow?.workflowId === 3;
  // DISABLE only if: estimate is linked to this encounter AND encounter is converted
  return isEstimateLinkedToEncounter && isEncounterConverted;
} 